<div class="section-ai-response-footer">
    @if (showAlert())  {
        <div class="text-center" [ngClass]="{'fade-out': fadeOutAlert()}">
            <div class="toast toast-success">
                <svg class="mr-1 fill-current" ycnIcon [name]="'icon-check'" role="img"></svg>
                <div class="toast-text">
                    <div class="text-bold">Copied to clipboard</div>
                </div>
            </div>
        </div>
    }

    <div class="section-ai-feedback">
        <div>
            <button
                class="btn btn-transparent2 btn-circle"
                ycnTooltip tooltipTitle="Copy to clipboard" [tooltipPlacement]="'top'"
                (click)="copyAIResponse()">
                <svg ycnIcon name="icon-copy" role="img"></svg>
            </button>
            <button
                class="btn btn-transparent2 btn-circle"
                ycnTooltip tooltipTitle="Delete chat" [tooltipPlacement]="'top'"
                (click)="deleteChat.emit()">
                <svg ycnIcon name="icon-delete" role="img"></svg>
            </button>
        </div>
    </div>
</div>
